module.exports = __webpack_public_path__ + "static/img/technology-4.55bb104d.png";